export default "__VITE_ASSET__RhoNWwyQ__"